import { Component } from '@angular/core';

@Component({
  selector: 'app-ai-logic',
  imports: [],
  templateUrl: './ai-logic.html',
  styleUrl: './ai-logic.scss'
})
export class AiLogic {

}
